export default {
  isAuthenticated: state => !!state.idToken && state.authStatus,
  getTagFilters: state => state.tagFilters,
};
